import React from 'react';
import Chart from 'react-google-charts';

const PieChartTopics = ({topics,friendName}) => {
  // Create an array with the custom legend labels

  const chartDataWithLabels = [
    ['Topic', 'Problems Count'],
  ]
  if(topics!==undefined && topics!==null)
  {
      let ind=0;
      for(let key in topics)
      {
          ind++;
          chartDataWithLabels.push([key,topics[key]])
          if(ind==4)break;
      }
  }
  const backgroundColor = '#282828';
  const chartColors = ['#FAC74E', '#59A5D8', '#E76F51','#32cd32', '#E76F51'];

  const chartContainerStyle = {
    width: '100%',
    height: '300px',
    borderRadius: '10px',
    overflow: 'hidden', 
  };

  return (
    <div style={chartContainerStyle}>
      <Chart
        width={'100%'}
        height={'300px'}
        chartType="PieChart"
        loader={
          <div className='d-flex justify-content-center align-items-center mb-3' style={{color:"white"}}>
        Loading Chart.....
      </div>}
        data={chartDataWithLabels} 
        options={{
          title: friendName!==undefined?`Top 4 ${friendName}'s Topics`:'Top 4 Solved Topics',
          backgroundColor,
          pieSliceBorderColor: backgroundColor,
          titleTextStyle: {
            color: '#9fa1a4',
            fontSize: 16,
          },
          legend: {
            position: 'right', 
            alignment: 'center',
            textStyle: {
              color: 'white',
              fontSize: 14,
            },
          },
          slices: chartColors.map((color) => ({ color })),
        }}
        rootProps={{ 'data-testid': '1' }}
      />
    </div>
  );
};

export default PieChartTopics;
